(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["elfi-options"] && !Shopify.designMode) return;
  try {
    if (!window.__elfiOptionsInit) {
    window.__elfiOptionsInit = true;
    var KEY = 'elfi_addons';
    function scope(el){ return el.closest('.product-information') || document; }
    function picker(el){ return scope(el).querySelector('variant-picker'); }
    function restore(root){
      var saved = []; try { saved = JSON.parse(sessionStorage.getItem(KEY) || '[]'); } catch(e){}
      (root || document).querySelectorAll('[data-eo-addon]').forEach(function(i){ i.checked = saved.indexOf(i.value) > -1; });
    }
    function syncHidden(root){
      var box = (root || document).querySelector('[data-eo-addons]'); if (!box) return;
      var form = scope(box).querySelector('form[action*="/cart/add"]'); if (!form) return;
      var want = box.hidden ? [] : Array.prototype.map.call(box.querySelectorAll('[data-eo-addon]:checked'), function(i){ return i.value; });
      var have = Array.prototype.map.call(form.querySelectorAll('[data-eo-hidden][name$="[id]"]'), function(i){ return i.value; });
      if (want.join(',') === have.join(',')) return;
      form.querySelectorAll('[data-eo-hidden]').forEach(function(n){ n.remove(); });
      var n = 0;
      box.querySelectorAll('[data-eo-addon]:checked').forEach(function(i){
        if (box.hidden) return;
        var a = document.createElement('input'); a.type = 'hidden'; a.name = 'items[' + n + '][id]'; a.value = i.value; a.setAttribute('data-eo-hidden', '');
        var q = document.createElement('input'); q.type = 'hidden'; q.name = 'items[' + n + '][quantity]'; q.value = '1'; q.setAttribute('data-eo-hidden', '');
        form.appendChild(a); form.appendChild(q); n++;
      });
    }
    function syncAddons(root){
      var box = (root || document).querySelector('[data-eo-addons]'); if (!box) return;
      var vp = picker(box); if (!vp) return;
      var on = false;
      vp.querySelectorAll('input[type=radio]:checked').forEach(function(i){ if (i.dataset.optionName === box.dataset.whenOpt && i.value === box.dataset.whenVal) on = true; });
      box.hidden = !on;
      if (!on) { box.querySelectorAll('[data-eo-addon]').forEach(function(i){ i.checked = false; }); try { sessionStorage.removeItem(KEY); } catch(err){} }
      syncHidden(root);
    }
    function zl(c, trim){ var v = (c / 100); if (trim && c % 100 === 0) return v.toFixed(0) + ' zł'; return v.toFixed(2).replace('.', ',') + ' zł'; }
    function put(el, v, html){ if (!el) return; if (html) { if (el.innerHTML !== v) el.innerHTML = v; } else if (el.textContent !== v) el.textContent = v; }
    function reprice(root){
      (root || document).querySelectorAll('[data-elfi-options]').forEach(function(box){
        var js = box.querySelector('[data-eo-variants]'); if (!js) return;
        var data; try { data = JSON.parse(js.textContent); } catch(e){ return; }
        var opts = data.options, sel = {};
        box.querySelectorAll('.eo-card.is-on').forEach(function(c){ sel[c.dataset.eoOpt] = c.dataset.eoVal; });
        function price(over){
          var want = opts.map(function(n){ return over[n] !== undefined ? over[n] : sel[n]; });
          for (var i = 0; i < data.variants.length; i++){ var v = data.variants[i]; if (v.o.join('|') === want.join('|')) return v.p; }
          return null;
        }
        var firstOf = {};
        box.querySelectorAll('.eo-cards').forEach(function(g){ var f = g.querySelector('.eo-card'); if (f) firstOf[f.dataset.eoOpt] = f.dataset.eoVal; });
        box.querySelectorAll('.eo-card').forEach(function(c){
          var o = {}; o[c.dataset.eoOpt] = c.dataset.eoVal;
          var pr = price(o); var el = c.querySelector('[data-eo-price]'); if (pr === null || !el) return;
          if (c.dataset.eoOpt === data.delta){
            var b = {}; b[data.delta] = firstOf[data.delta]; var d = pr - price(b);
            put(el, d > 0 ? '+' + zl(d) : (d < 0 ? zl(d) : '<em>w cenie</em>'), true);
          } else {
            put(el, zl(pr));
            var cmp = c.querySelector('[data-eo-cmp-base]');
            if (cmp){
              var r = {}; r[c.dataset.eoOpt] = c.dataset.eoVal; r[data.delta] = firstOf[data.delta];
              var ref = price(r); var base = parseInt(cmp.dataset.eoCmpBase, 10) + (ref === null ? 0 : pr - ref);
              put(cmp.querySelector('[data-eo-cmp]'), zl(base, true));
              put(cmp.querySelector('[data-eo-pct]'), '−' + Math.round((base - pr) * 100 / base) + '%');
            }
          }
        });
      });
    }
    document.addEventListener('click', function(e){
      var card = e.target.closest('.eo-card'); if (!card) return;
      var vp = picker(card); if (!vp) return;
      var inputs = vp.querySelectorAll('input[type=radio][data-option-name]');
      var hit = null;
      inputs.forEach(function(i){ if (i.dataset.optionName === card.dataset.eoOpt && i.value === card.dataset.eoVal) hit = i; });
      if (hit && !hit.checked) { hit.click(); }
      card.closest('.eo-cards').querySelectorAll('.eo-card').forEach(function(c){ c.classList.toggle('is-on', c === card); c.setAttribute('aria-pressed', c === card); });
      reprice(card.closest('[data-elfi-options]').parentNode);
      syncAddons(card.closest('[data-elfi-options]'));
      setTimeout(function(){ syncAddons(document); }, 900);
    });
    document.addEventListener('change', function(e){
      if (!e.target.matches('[data-eo-addon]')) return;
      var ids = Array.prototype.map.call(document.querySelectorAll('[data-eo-addon]:checked'), function(i){ return i.value; });
      try { sessionStorage.setItem(KEY, JSON.stringify(ids)); } catch(err){}
      syncHidden(scope(e.target));
    });
    document.addEventListener('cart:update', function(){ try { sessionStorage.removeItem(KEY); } catch(err){} document.querySelectorAll('[data-eo-addon]').forEach(function(i){ i.checked = false; }); syncHidden(document); });
    var t;
    new MutationObserver(function(){ clearTimeout(t); t = setTimeout(function(){ restore(document); syncAddons(document); reprice(document); }, 60); }).observe(document.documentElement, {childList:true, subtree:true});
    restore(document); syncAddons(document); reprice(document);
  }
  } catch(e) { console.error(e); }
})();

})();
